import { Link } from 'react-router-dom';
import { BadgeCheck } from 'lucide-react';
import { colors } from '../../lib/theme';

export function Footer() {
  return (
    <footer className="mt-5" style={{ borderTop: `1px solid ${colors.borderDark}` }}>
      <div className="mx-auto max-w-page px-6 py-6 text-[13px] flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" style={{ color: colors.textMuted }}>
        <div className="flex items-center gap-2">
          <BadgeCheck className="h-4 w-4" />
          <span>Best-effort research. Please verify before investing.</span>
        </div>
        <div className="flex flex-wrap items-center gap-4">
          <Link to="/methodology" className="hover:opacity-80 transition-opacity">
            Methodology
          </Link>
          <Link to="/disclaimer" className="hover:opacity-80 transition-opacity">
            Disclaimer
          </Link>
          <Link to="/privacy" className="hover:opacity-80 transition-opacity">
            Privacy
          </Link>
          <Link to="/security" className="hover:opacity-80 transition-opacity">
            Security
          </Link>
        </div>
      </div>
    </footer>
  );
}
